<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Negar Solicitação</h3>
				</div>
				<div class="modal-body">
					<div class="row">
                        <div class="col-md-12">
							<div class="form-group">
								<label>Motivo: </label>
								<select ref="motivo" v-model="dados.motivo" class="form-control">
                                    <option value="Restrição no CNPJ ligado ao cliente">Restrição no CNPJ ligado ao cliente</option>
                                    <option value="Restrição no avalista">Restrição no avalista</option>
                                    <option value="Restrição no sócio da empresa">Restrição no sócio da empresa</option>
                                    <option value="Baixo escore de crédito">Baixo escore de crédito</option>
                                    <option value="Telefone não localizado ou sem contato">Telefone não localizado ou sem contato</option>
                                    <option value="Terceiro suspeito">Terceiro suspeito</option><option value="Filling">Filling</option>
                                    <option value="Outro">Outro</option>
                                </select>
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Observação: </label>
								<textarea ref="observacao" v-model="dados.observacao" class="form-control" rows="6"></textarea>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="text-right" style="float:right">
						<button class="btn btn-default" @click="$emit('close')">
							<i class="fa fa-close"></i> Fechar
						</button>
						<button class="btn btn-primary" @click="$emit('negar', dados.motivo, dados.observacao)">
							Confirmar
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		props: [],
		filters: {},
		data: () => ({
			dados: {
                motivo: 'Restrição no CNPJ ligado ao cliente',
				observacao: ''
			}
		}),
		mounted() {
			this.$refs.observacao.focus();
		},
		methods: {

		},
		components: {}
	};
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 1001;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		transition: opacity .3s ease;
	}

	.modal-container {
		width: 50%;
		height: auto;
		margin: 60px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		height: 250px;
		overflow-y: auto;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal {
		display: block !important;
		/* I added this to see the modal, you don't need this */
	}


	/* Important part */

	.modal-dialog {
		overflow-y: initial !important;
	}

	.modal-body {
		height: 300px;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// modalNegar.vue?32dfda35